import React from 'react';
const IconLoader = () => (
  <svg id="logo" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
    <title>Loader Logo</title>
    <g>
     <g transform="translate(87, 5) scale(-1, 1)">
        <path
          d="M48,35 C48,30 44,28 38,28 C32,28 28,30 26,34 L31,36 C32,33 34,31.5 38,31.5 C42,31.5 44.5,33 44.5,35.5 C44.5,38 42,39.5 37,40.5 C31,41.8 26,44 26,49 C26,54 30,58 38,58 C44,58 47.5,56 49,52 L43.5,50 C42.5,52.5 40.5,54 38,54 C34,54 31.5,52.5 31.5,49.5 C31.5,46.5 34,45 38,44 C44,42.5 48,40.5 48,35 Z"
          fill="currentColor"
        />
      </g>
      <path
        stroke="currentColor"
        strokeWidth="5"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M 50, 5
                  L 11, 27
                  L 11, 72
                  L 50, 95
                  L 89, 73
                  L 89, 28 z"
      />
    </g>
  </svg>
);
export default IconLoader;